import parseHTML from "../parseHTML";
import sanitize from "../parseHTML/purify";

export const sanitizeBreadcrumbs = ( breadcrumb ) => breadcrumb?.map( crumb =>
    ({
        id: crumb.id ? parseInt( crumb.id, 10 ) : null,
        term_id: crumb.term_id ? parseInt( crumb.term_id, 10 ) : null,
        text: parseHTML( crumb.text, ['learningCenter'] ).parsed,
        url: sanitize( crumb.url )
    }));
